import { useCallback, useMemo } from "react"

import { Flex } from "antd"
import dayjs from "dayjs"
import { useSelector } from "react-redux"

import { getCalculatedPeriod } from "../../../Utils/utils"
import { AlertsTypeToggle } from "../AlertsTypeToggle"
import CompareSelect from "../CompareSelect"
import DropdownDateBlock from "../DropdownDateBlock/DropdownDateBlock"
import { resolveCompare } from "./resolveCompare"

export const DashboardFiltersBlock = ({
  onlyPeriod,
  showCompare,
  filters,
  handleChangeFilter,
  disabled
}) => {
  const isMobile = useSelector((state) => state.nav.isMobile)

  const handleChangeCustomDate = useCallback(
    (newFilters) => {
      if (!newFilters?.period) {
        setTimeout(() => handleChangeFilter({ period: "27 days" }), 100)
        return
      }

      const nextPeriod = newFilters.period
      const wasAllTime = filters?.period === "all"
      const goingToAllTime = nextPeriod === "all"

      const buildCompareFields = () => {
        if (goingToAllTime) {
          return {
            lastCompare: filters?.compare || filters?.lastCompare || null,
            compare: null
          }
        }

        const sourceCompare = wasAllTime ? filters?.lastCompare : filters?.compare

        return {
          compare: resolveCompare(sourceCompare, nextPeriod),
          lastCompare: wasAllTime ? null : filters?.lastCompare
        }
      }

      handleChangeFilter({
        ...newFilters,
        ...(showCompare ? buildCompareFields() : {})
      })
    },
    [showCompare, filters?.period, filters?.compare, filters?.lastCompare, handleChangeFilter]
  )

  const compareCurrentValue = useMemo(() => {
    const calculated = getCalculatedPeriod(filters?.period)
    if (!calculated) return null
    const [from, to] = calculated
    return {
      preset: filters?.period?.type === "custom" ? "custom" : "relative",
      range: [
        dayjs.isDayjs(from) ? from.format("YYYY-MM-DD") : from,
        dayjs.isDayjs(to) ? to.format("YYYY-MM-DD") : to
      ]
    }
  }, [filters?.period])

  return (
    <Flex gap={12} style={{ flexDirection: isMobile && "column", width: isMobile && "100%" }}>
      {!onlyPeriod && (
        <AlertsTypeToggle
          value={filters?.alertsType}
          onChange={handleChangeFilter}
          disabled={disabled}
        />
      )}

      <DropdownDateBlock
        id={"period"}
        customOverlayClassName={"dashboard-filters"}
        label={"Custom"}
        iconType={"calendar_days"}
        setDropdownFilters={handleChangeCustomDate}
        dropdownFilters={getCalculatedPeriod(filters?.period)}
        presetId={filters?.__preset_period}
        disabled={disabled}
        inactive={false}
        alwaysShowLabel={false}
      />

      {showCompare && (
        <CompareSelect
          currentValue={compareCurrentValue}
          value={filters?.compare}
          onChange={(val) => handleChangeFilter({ compare: val })}
          disabled={disabled || filters?.period === "all"}
        />
      )}
    </Flex>
  )
}
